module.exports = __webpack_public_path__ + "static/media/Trophy.1349e187.svg";